import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=144795ea&scoped=true&"
import script from "./WhyUs.vue?vue&type=script&lang=ts&"
export * from "./WhyUs.vue?vue&type=script&lang=ts&"
import style0 from "./WhyUs.vue?vue&type=style&index=0&id=144795ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144795ea",
  null
  
)

export default component.exports